export const MIN_AGE_STARTDATE = 13;
export const MAX_AGE_STARTDATE = 99;
